import { render, staticRenderFns } from "./Graduation.vue?vue&type=template&id=5989f2a8"
import script from "./Graduation.vue?vue&type=script&lang=js"
export * from "./Graduation.vue?vue&type=script&lang=js"
import style0 from "./Graduation.vue?vue&type=style&index=0&id=5989f2a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports